import { Colors } from 'styles/CssVariables';
import {
  EAnimalCharginStatusDB,
  EAnimalCharginStatusUI,
  EAnimalTagsDB,
  EAnimalTagsUI,
  EConversionStatusDB,
  EConversionStatusUI,
} from '../types/animals.types';
import { EGender, EPetQuantityFilterDB, EPetQuantityFilterUI, TStatusMapper } from '../types/general.types';
import { EResidencyStatusDB, EResidencyStatusUI } from '../types/residence.types';
import { EPropertyStatusUI } from '../types/property.types';
import { ELandlordStatusDB, ELandlordStatusUI } from '../types/landlord.types';

export enum EText {
  DEFAULT_ERROR = 'Something went wrong',
  NO_EDIT_PERMISSION = "You don't have permission to edit this.",
  HP_FORM_TEXT = 'To verify documentation, OurPetPolicy uses a simple form for health professionals to complete with only the minimum information required to confirm an individual’s need for an assistance animal. The health professional can answer the questions on the form, by email, or by phone directly with OurPetPolicy. We will never ask for details about a patient’s disability or diagnosis.',
  HP_FORM_CREATE_TEXT = "Housing providers have the right to make the truth and accuracy of assistance animal documentation to the same extent they verify other material information during the leasing process, such as income verification. To facilitate this process for ESA and service animal letters, OurPetPolicy utilizes a simple form for the health professional to complete, which only asks the minimum information that is required to confirm an individual's need for an assistance animal as a reasonable accommodation. Health professionals are welcome to answer the questions on the form in another manner if preferred, such as over the phone or via email directly with OurPetPolicy. OurPetPolicy will never ask any details about a patient's disability or specific diagnosis. If you have any questions or concerns about this process, please contact us at support@ourpetpolicy.com.",
}

export const goToNextVideoStorageKey = 'goToNextVideo';

export const yesNoOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export const yesNoTrueFalseOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const onOfOptions = [
  { value: true, label: 'On' },
  { value: false, label: 'Off' },
];
export const hudGuidelinesLink =
  'https://www.hud.gov/sites/dfiles/PA/documents/HUDAsstAnimalNC1-28-2020.pdf?fbclid=IwAR3NcG1FMmTGaw7LZ__oMwWku7wWu4R51n6AbCyHw9tgUQgi95KiMc41C4Y';

export const chargingStatusMapper: TStatusMapper<EAnimalCharginStatusUI> = {
  [EAnimalCharginStatusUI.BEING_CHARGED]: {
    bgColor: Colors.SuccessColor,
  },
  [EAnimalCharginStatusUI.GRACE_PERIOD]: {
    bgColor: Colors.Blue,
  },
  [EAnimalCharginStatusUI.NOT_APPLICABLE]: {
    bgColor: Colors.DarkGrey,
  },
  [EAnimalCharginStatusUI.NOT_BEING_CHARGED]: {
    bgColor: Colors.ErrorColor,
  },
  [EAnimalCharginStatusUI.SHOULD_NOT]: {
    bgColor: Colors.PrimaryColor,
  },
  [EAnimalCharginStatusUI.UNSPECIFIED]: {
    bgColor: Colors.LightGrey,
  },
  [EAnimalCharginStatusUI.NO_PET_FEE]: {
    bgColor: Colors.DarkGrey,
  },
  [EAnimalCharginStatusUI.NO_PET_RENT]: {
    bgColor: Colors.DarkGrey,
  },
};

export const oldHud =
  'https://www.hud.gov/sites/dfiles/PA/documents/HUDAsstAnimalNC1-28-2020.pdf?fbclid=IwAR3NcG1FMmTGaw7LZ__oMwWku7wWu4R51n6AbCyHw9tgUQgi95KiMc41C4Y';

export const animalTypes = [
  { label: 'Pet', value: 'PET' },
  { label: 'ESA', value: 'ESA' },
  { label: 'SA', value: 'SA' },
];
export const conversionStatuses = [
  { label: 'All', value: '' },
  {
    label: EConversionStatusUI.PENDING_ESA,
    value: EConversionStatusDB.PENDING_ESA,
  },
  {
    label: EConversionStatusUI.PENDING_SA,
    value: EConversionStatusDB.PENDING_SA,
  },
  { label: EConversionStatusUI.NONE, value: EConversionStatusDB.NONE },
];

export const residencyStatusesOptions = [
  { label: EResidencyStatusUI.RESIDENT, value: EResidencyStatusDB.RESIDENT },
  { label: EResidencyStatusUI.APPLICANT, value: EResidencyStatusDB.APPLICANT },
  {
    label: EResidencyStatusUI.FUTURE_RESIDENT,
    value: EResidencyStatusDB.FUTURE_RESIDENT,
  },
  {
    label: EResidencyStatusUI.FORMER_RESIDENT,
    value: EResidencyStatusDB.FORMER_RESIDENT,
  },
  { label: EResidencyStatusUI.DENIED, value: EResidencyStatusDB.DENIED },
  { label: EResidencyStatusUI.RETRACTED, value: EResidencyStatusDB.RETRACTED },
  { label: EResidencyStatusUI.NOTICE, value: EResidencyStatusDB.NOTICE },
];

export const petStatusOptions = [
  { label: 'Yes', value: 'HAS_ANIMAL' },
  { label: 'No', value: 'HAS_NOT_ANIMAL' },
  { label: 'Not specified', value: 'NOT_SPECIFIED' },
];

export const numberOfAnimalsOptions = [
  { label: 'All', value: '' },
  { label: EPetQuantityFilterUI.ZERO, value: EPetQuantityFilterDB.ZERO },
  {
    label: EPetQuantityFilterUI.MORE_THAN_ZERO,
    value: EPetQuantityFilterDB.MORE_THAN_ZERO,
  },
];

export const employeeOptions = [
  { label: 'All', value: '' },

  { label: 'Yes', value: true },
  {
    label: 'No',
    value: 'false',
  },
];
export const unitAnimalPresenceOptions = [
  { label: 'Yes', value: 'YES' },
  { label: 'No', value: 'NO' },
  { label: 'Unspecified', value: 'UNSPECIFIED' },
  { label: 'Conflict', value: 'CONFLICT' },
  { label: 'Not Applicable', value: 'NOT_APPLICABLE' },
];

export const animalTagsInfo = {
  Known: ' Animal known to be living in the property at the time the property was registered in OurPetPolicy.',
  PNC: 'Previously Not Charged animal that wasn’t initially paying fees but started paying due to OurPetPolicy.',
};

export const residentTagsInfo = {
  Known: 'Tenant residing in the property at the time the property was registered in OurPetPolicy.',
};

export const charginStatusValues = [
  {
    label: EAnimalCharginStatusUI.BEING_CHARGED,
    value: EAnimalCharginStatusDB.BEING_CHARGED,
  },
  {
    label: EAnimalCharginStatusUI.GRACE_PERIOD,
    value: EAnimalCharginStatusDB.GRACE_PERIOD,
  },
  {
    label: EAnimalCharginStatusUI.NOT_APPLICABLE,
    value: EAnimalCharginStatusDB.NOT_APPLICABLE,
  },
  {
    label: EAnimalCharginStatusUI.NOT_BEING_CHARGED,
    value: EAnimalCharginStatusDB.NOT_BEING_CHARGED,
  },
  {
    label: EAnimalCharginStatusUI.SHOULD_NOT,
    value: EAnimalCharginStatusDB.SHOULD_NOT,
  },
  {
    label: EAnimalCharginStatusUI.UNSPECIFIED,
    value: EAnimalCharginStatusDB.UNSPECIFIED,
  },
];

export const addedAnimalsTagValues = [
  { label: 'PNC Pet Rent', value: 'PNC_PET_RENT' },
  { label: 'PNC Pet Fee', value: 'PNC_PET_FEE' },
  { label: 'CNC Pet Rent', value: 'CNC_PET_RENT' },
  { label: 'CNC Pet Fee', value: 'CNC_PET_FEE' },
  { label: 'Converted', value: 'CONVERTED' },
];

export const allAndCurrentAnimalsTableTagValues = [
  { label: 'Known', value: 'KNOWN' },
  { label: EAnimalTagsUI.DISCOVERD, value: EAnimalTagsDB.DISCOVERD },
  { label: EAnimalTagsUI.DISCOVERED_APP, value: EAnimalTagsDB.DISCOVERED_APP },
  { label: EAnimalTagsUI.DISCOVERED_PAYING, value: EAnimalTagsDB.DISCOVERED_PAYING },
];

export const pendingAnimalsTableTagValues = [
  { label: 'Discovered', value: 'DISCOVERED' },
  { label: 'Known', value: 'KNOWN' },
];

export const animalTagsTootipTitles = {
  [EAnimalTagsUI.PNC_PET_FEE]:
    'Previously Not Charged pet that wasn’t initially paying fees but started paying due to OurPetPolicy.',
  [EAnimalTagsUI.PNC_PET_RENT]:
    'Previously Not Charged pet that wasn’t initially paying fees but started paying due to OurPetPolicy.',
  [EAnimalTagsUI.CNC_PET_FEE]: 'Currently Not Charged.',
  [EAnimalTagsUI.CNC_PET_RENT]: 'Currently Not Charged.',
  [EAnimalTagsUI.KNOWN]:
    'Animal known to be living in the property at the time the property was registered in OurPetPolicy.',
};

export const propertyStatusColor = {
  [EPropertyStatusUI.ACTIVE]: Colors.SuccessColor,
  [EPropertyStatusUI.PENDING]: Colors.WarningColor,
};

export const propertyStatusActionColor = {
  [EPropertyStatusUI.ACTIVE]: Colors.Grey,
  [EPropertyStatusUI.PENDING]: Colors.Black,
};
export const genderOption = [
  { value: EGender.MALE, label: 'Male' },
  { value: EGender.FEMALE, label: 'Female' },
];
export const propertyRemoveConfirmText = 'REMOVE PROPERTY';

export const vaccinationData = ['Rabies', 'Spayed/Neutered', 'Dog liability insurance'];

export const hasESADocumentationOptions = [
  { value: true, label: 'I have ESA health documentation' },
  { value: false, label: `I don't have ESA health documentation` },
];

export const hasSADocumentationOptions = [
  { value: true, label: 'I have health professional documentation' },
  { value: false, label: `I don't have health professional documentation` },
];

// export const hasSATrainerDocumentationOptions = [
//   { value: true, label: 'I have SA trainer documentation' },
//   { value: false, label: 'I don’t have SA trainer documentation' },
// ];

export const propertyManagementStatusOptions = [
  {
    label: ELandlordStatusUI.ACTIVE,
    value: ELandlordStatusDB.ACTIVE,
    isSelected: true,
  },
  { label: ELandlordStatusUI.INACTIVE, value: ELandlordStatusDB.INACTIVE },
  {
    label: ELandlordStatusUI.NON_LANDLORD,
    value: ELandlordStatusDB.NON_LANDLORD,
  },
  { label: ELandlordStatusUI.PROSPECT, value: ELandlordStatusDB.PROSPECT },
  { label: ELandlordStatusUI.TEST, value: ELandlordStatusDB.TEST },
];

export enum EApproveWarningText {
  ALLOW = 'You are going to approve an animal which is not verified. Would you like to proceed?',
  BLOCK = 'Approval of assistance animals can only proceed after the system verifies them as ESA or SA, marked by a "Verified" status. Approving unverified assistance animals may result in a loss of pet rent and fees if the verification fails and the animal is converted to PET. If you have any questions or believe the animal should be approved, please contact our support team at support@ourpetpolicy.com.',
}

export const scheduledReportsOptions = [
  { label: 'All', value: '' },
  { label: 'Pet Charge Report - ON', value: 'true' },
  { label: 'Pet Charge Report - OFF', value: 'false' },
];

export const FREQUENCY_OPTIONS = [
  { value: 'MONTHLY', label: 'Monthly' },
  { value: 'QUARTERLY', label: 'Quarterly' },
  { value: 'BIANNUALLY', label: 'Bi-annually' },
];

export const TIMEZONE_OPTIONS = [
  { value: 'EASTERN', label: 'Eastern' },
  { value: 'CENTRAL', label: 'Central' },
  { value: 'MOUNTAIN', label: 'Mountain' },
  { value: 'PACIFIC', label: 'Pacific' },
  { value: 'ALASKA', label: 'Alaska' },
  { value: 'HAWAII', label: 'Hawaii' },
];
